import { render, staticRenderFns } from "./HelpBtn.vue?vue&type=template&id=cd877fc6&scoped=true"
import script from "./HelpBtn.vue?vue&type=script&lang=js"
export * from "./HelpBtn.vue?vue&type=script&lang=js"
import style0 from "./HelpBtn.vue?vue&type=style&index=0&id=cd877fc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd877fc6",
  null
  
)

export default component.exports